import BottomBlock from './components/BottomBlock';
import ContentBlock from './components/ContentBlock';
import AgentHeader from './components/Header';
import { pageData } from './data';

import * as ST from './styled';

const Agent = (): JSX.Element => {
    return (
        <ST.PageWrapper>
            <AgentHeader data-test='agent-header'/>
            <ST.ContentWrapper>
                <ST.ContainerWide>
                    <ST.ContentContainer>
                        {pageData.map(block => (
                            <ContentBlock
                                key={block.id}
                                blockData={block}
                                data-test='content-block'
                            />
                        ))}
                    </ST.ContentContainer>
                    <BottomBlock data-test='bottom-block'/>
                </ST.ContainerWide>
            </ST.ContentWrapper>
        </ST.PageWrapper>
    );
};

export default Agent;
